import { UserLayout } from '@/layouts'

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouters = [
  {
    path: '/redirect/:path*',
    component: () => import(/* webpackChunkName: "user" */ '@/views/redirect/index'),
  },

  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login'),
      },
    ],
  },
  {
    path: '/processEditor',
    name: 'processEditor',
    component: () => import(/* webpackChunkName: "process" */ '@/views/ProcessEditor'),
  },
  {
    path: '/formParser',
    name: 'formParser',
    component: () => import(/* webpackChunkName: "formParser" */ '@/views/formParser/index.vue'),
  },
  {
    path: '/performanceSubmit',
    name: 'performanceSubmit',
    component: () => import(/* webpackChunkName: "performance" */ '@/views/performance/performanceSubmit/index.vue'),
  },
  {
    path: '/performanceProcess',
    name: 'performanceProcess',
    component: () => import(/* webpackChunkName: "performance" */ '@/views/performance/performanceProcess/index.vue'),
  },
  {
    path: '/403',
    name: '403',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception'),
  },
  {
    path: '/500',
    name: '500',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception'),
  },
]
